import { createApi } from "@reduxjs/toolkit/query/react";
import { APICall } from "@/config/NetworkUtility";

const customBaseQuery = async ({ url, method = "get", body, params }) => {
    try {
        const query = params
            ? new URLSearchParams(params).toString()
            : "";

        const endpoint = query
            ? `${url}?${query}`
            : url;

        const result = await APICall(
            method,
            body ?? null,
            endpoint
        );

        return { data: result };
    } catch (error) {
        return {
            error: {
                status: error?.response?.status ?? 500,
                data:
                    error?.response?.data ??
                    error?.message ??
                    "Request failed",
            },
        };
    }
};

export const sidebarNavigationApi = createApi({
    reducerPath: "sidebarNavigationApi",
    baseQuery: customBaseQuery,

    tagTypes: ["SidebarNavigation"],

    endpoints: (builder) => ({
        // =====================================================
        // GET NAVIGATION SEQUENCE
        // =====================================================
        getSidebarNavigation: builder.query({
            query: (companyId) => ({
                url: "v1/CompanyNavigationSetup/GetNavigationSequenceDetailList",
                method: "get",
                params: {
                    CompanyId: companyId,
                },
            }),

            transformResponse: (response) =>
                response?.data ?? response ?? [],

            providesTags: (result, error, companyId) => [
                {
                    type: "SidebarNavigation",
                    id: companyId,
                },
            ],
        }),

        // =====================================================
        // UPDATE NAVIGATION SEQUENCE
        // =====================================================
        updateSidebarNavigation: builder.mutation({
            query: ({ companyId, payload }) => {
                const formData = new FormData();

                formData.append(
                    "CompanyId",
                    String(companyId)
                );

                formData.append(
                    "JsonStringValue",
                    JSON.stringify(payload)
                );

                return {
                    url: "v1/CompanyNavigationSetup/GetNavigationSequenceDetailProcess",
                    method: "post",
                    body: formData,
                };
            },

            transformResponse: (response) =>
                response?.data ?? response,

            // Automatically refetch GET after successful update
            invalidatesTags: (result, error, { companyId }) => [
                {
                    type: "SidebarNavigation",
                    id: companyId,
                },
            ],
        }),
    }),
});

export const {
    useGetSidebarNavigationQuery,
    useUpdateSidebarNavigationMutation,
} = sidebarNavigationApi;